import React, { ReactChild, useEffect } from 'react'
import Button from '../../../../../components/button/Button'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { request } from '../../MakeRequestContext'
import { useMediaQuery } from 'react-responsive'
import { modalTypes } from '../../../../../enums/modalTypeEnum'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import fr from '../../../../../translations/fr'
import { propertyType } from '../../../../../enums/contractsEnum'
import links from '../../../../../enums/linksEnum'
import { useHistory } from 'react-router-dom'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			containerStyle: {
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',

				'& > div': {
					textAlign: 'left'
				}
			},
			containerSmallScreenStyle: {
				width: '100%',
				padding: 15,
				margin: 'auto',

				'& div:nth-child(2)': {
					margin: 'auto',

					'& img': {
						width: '100%'
					}
				}
			},
			buttonsContainerStyle: {
				'& div:first-child': {
					marginBottom: 15
				}
			}
		}
	)
)

interface AcceptingProps {
	title: ReactChild,
	text: ReactChild,
	closeDialog: () => void,
	fromType: modalTypes,
	resetStep?: () => void
}

type RequestSummaryProps = AcceptingProps

const RequestSummary: React.FC<RequestSummaryProps> = (
	{
		title,
		text,
		closeDialog,
		fromType,
		resetStep
	}
) => {
	const classes = useStyle()
	const history = useHistory()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const containerClass: ClassValue = classNames(
		'row',
		classes.containerStyle,
		{
			[classes.flexColumnReverse]: !isLargeScreen,
			[classes.containerSmallScreenStyle]: !isLargeScreen
		}
	)

	const titleClass: ClassValue = classNames(
		classes.colorBlue,
		{
			[classes.title1]: isLargeScreen,
			[classes.title6]: !isLargeScreen
		}
	)

	const textClass: ClassValue = classNames(
		classes.colorBlue,
		{
			[classes.text13_opacity]: isLargeScreen,
			[classes.text2_opacity]: !isLargeScreen
		}
	)

	const buttonsContainerClass: ClassValue = classNames(
		'row',
		{
			[classes.buttonsContainerStyle]: !isLargeScreen
		}
	)

	useEffect(
		() => {
			if (fromType === modalTypes.demandes) {
				saveInteractions(
					{
						category: 'Vos Demandes',
						action: 'Déposer une demande',
						// @ts-ignore
						label: `Etape 5::Bien concerné::${request.contract?.type === propertyType.apartment ? 'Appartement' : 'Parking'}::${fr[`requests.makeRequest.step1.${request.requestType}`]}::${fr[`requests.makeRequest.step2.${request.requestPurpose}`]}::${fr[`requests.makeRequest.step3.${request.requestConcern}`]}::Demande envoyée`
					}
				)
			}
		}, [fromType]
	)

	const finish = () => {
		if (fromType === modalTypes.demandes) {
			resetStep && resetStep()

			request.propertyConcerned = ''
			request.residence = ''
			request.interlocutor = ''
			request.requestType = ''
			request.requestPurpose = ''
			request.requestConcern = ''
			closeDialog()
		}
		history.push(links.requests)
		window.location.reload()
	}

	const makeAnotherRequest = () => {
		if (fromType === modalTypes.demandes) {
			resetStep && resetStep()

			request.propertyConcerned = ''
			request.residence = ''
			request.interlocutor = ''
			request.requestType = ''
			request.requestPurpose = ''
			request.requestConcern = ''
		}
	}

	return (
		<div className={containerClass}>
			<div className="col-xs-12 col-md-8 center-sm">
				<h1 className={titleClass}>
					{title}
				</h1>

				<p className={textClass}>
					{text}
				</p>

				<div className={buttonsContainerClass}>
					<div className="col-xs-12 col-md-6">
						<Button
							background="backgroundAccessibility"
							color="colorWhite"
							textStyle="text8"
							size="bigButton"
							onClick={finish}
						>
							<FormattedMessage
								id="requests.makeRequest.step5.finish"
								defaultMessage="Terminer"
								description="Summary button"
							/>
						</Button>
					</div>

					{
						fromType === modalTypes.demandes && (
							<div className="col-xs-12 col-md-6">
								<Button
									background="backgroundWhite"
									color="colorAccessibility"
									textStyle="text8"
									size="bigButton"
									onClick={makeAnotherRequest}
									border="borderGreen"
								>
									<FormattedMessage
										id="requests.makeRequest.step5.remakeRequest"
										defaultMessage="Déposer une nouvelle demande"
										description="Summary button"
									/>
								</Button>
							</div>
						)
					}
				</div>
			</div>

			<div className="col-xs-12 col-sm-4 center-sm">
				<img
					src="img/contracts/requestSummary/sendImg.png"
					alt="Send icon"
				/>
			</div>
		</div>
	)
}

export default RequestSummary